import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const MyHome = () => import('@/components/routes/MyHome')
const MyBody = () => import('@/components/objects/MyBody')
const MyComponents = {
  MyBusinessCeo: () => import(/* webpackChunkName: "group-business" */ '@/components/routes/MyBusinessCeo'),
  MyBusinessPerformance: () => import(/* webpackChunkName: "group-business" */ '@/components/routes/MyBusinessPerformance'),
  MyBusinessVision: () => import(/* webpackChunkName: "group-business" */ '@/components/routes/MyBusinessVision'),
  MyBusinessPeople: () => import(/* webpackChunkName: "group-business" */ '@/components/routes/MyBusinessPeople'),
  MyBusinessOperations: () => import(/* webpackChunkName: "group-business" */ '@/components/routes/MyBusinessOperations'),
  MyFocus: () => import(/* webpackChunkName: "group-focus" */ '@/components/routes/MyFocus'),
  MyFutureLandscape: () => import(/* webpackChunkName: "group-future" */ '@/components/routes/MyFutureLandscape'),
  MyFutureExplore: () => import(/* webpackChunkName: "group-future" */ '@/components/routes/MyFutureExplore'),
  MyFinancials: () => import(/* webpackChunkName: "group-financials" */ '@/components/routes/MyFinancials'),
  MyGovernanceTransparency: () => import(/* webpackChunkName: "group-governance" */ '@/components/routes/MyGovernanceTransparency'),
  MyGovernanceResilience: () => import(/* webpackChunkName: "group-governance" */ '@/components/routes/MyGovernanceResilience'),
  MyGovernanceExecutive: () => import(/* webpackChunkName: "group-governance" */ '@/components/routes/MyGovernanceExecutive'),
  MyGovernanceBoard: () => import(/* webpackChunkName: "group-governance" */ '@/components/routes/MyGovernanceBoard'),
  MyServices: () => import(/* webpackChunkName: "group-services" */ '@/components/routes/MyServices')
}

Vue.use(Router)

// const routes = [
//   {
//     path: '/',
//     name: 'MyHome',
//     component: MyHome
//   }
// ]

const menuRoutes = store.state.pages.map((item) => {
  let routeObj = {
    path: `/${item.parent.slug}`,
    name: item.parent.name,
    props: { title: item.parent.title },
    meta: { title: item.parent.title }
  }
  if (item.children) {
    routeObj = {
      ...routeObj,
      ...{
        component: MyBody,
        redirect: { name: item.children[0].name },
        children: item.children.map((subItem) => {
          return {
            path: `/${item.parent.slug}/${subItem.slug}`,
            name: subItem.name,
            props: {
              slug: subItem.slug,
              title: subItem.title
            },
            component: item.parent.shared ? MyComponents[item.parent.name] : MyComponents[subItem.name],
            meta: {
              color: subItem.color || 'default',
              title: subItem.title
            }
          }
        })
      }
    }
  } else {
    routeObj = {
      ...routeObj,
      ...{
        component: (item.parent.slug === '') ? MyHome : MyComponents[item.parent.name]
      }
    }
  }
  return routeObj
})

const router = new Router({
  routes: menuRoutes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('setPrimaryRouteName', to.matched[0].name)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js